import { render, staticRenderFns } from "./IconUpload.vue?vue&type=template&id=fa8b8bca"
import script from "./IconUpload.vue?vue&type=script&lang=ts"
export * from "./IconUpload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports